import { ZodType, ZodTypeDef } from 'zod';
import { apiFetch } from 'packages/lib/api/annotations/rest';

/**
 * Annotations API Fetcher
 */
export const omnitagFetch = apiFetch('omnitag', { 'If-Match': '*' });

export const omnitagAPIGet = async <T, Z extends ZodTypeDef = ZodTypeDef>(
  endpoint: string,
  zodParse: ZodType<T, Z>['parse']
): Promise<T> => {
  const resp = await omnitagFetch(endpoint);
  const json = await resp.json();

  try {
    return zodParse(json);
  } catch (e) {
    // Make it easier to debug Zod parse errors
    console.error('Zod Failed to parse data for endpoint: ', endpoint);
    console.error('  JSON that failed parsing: ', json);
    throw e;
  }
};

export const omnitagAPIPost = async <P, T, Z extends ZodTypeDef = ZodTypeDef>(
  endpoint: string,
  postBody: P,
  zodParse: ZodType<T, Z>['parse']
): Promise<T> =>
  zodParse(
    await omnitagFetch(endpoint, 'POST', JSON.stringify(postBody)).then((r) =>
      r.json()
    )
  );
